module.exports = __webpack_public_path__ + "img/6.cdca2fdd.jpg";